import {RootState} from '../rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const financeAdminStatus = createSelector(
  [(state: RootState) => state.financeAdmin.isLoading],
  isLoading => isLoading,
);

export const financeAdminRefundLoadingSelector = createSelector(
  [(state: RootState) => state.financeAdmin.refundLoading],
  refundLoading => refundLoading ?? false,
);

export const financeAdminChangePayoutStatusLoadingSelector = createSelector(
  [(state: RootState) => state.financeAdmin.changePayoutStatusLoading],
  changePayoutStatusLoading => changePayoutStatusLoading ?? false,
);

export const financeAdminSuccessSelector = createSelector(
  [(state: RootState) => state.financeAdmin.financeAdminSuccess],
  financeAdminSuccess => financeAdminSuccess,
);

export const financeAdminFailureSelector = createSelector(
  [(state: RootState) => state.financeAdmin.financeAdminFailure],
  financeAdminFailure => financeAdminFailure,
);

export const financePaymentsSelector = createSelector(
  [(state: RootState) => state.financeAdmin.payments.payments],
  payments => payments || [],
);

export const financePaymentsNextPageSelector = createSelector(
  [(state: RootState) => state.financeAdmin.payments.next_page],
  nextPage => nextPage ?? null,
);

export const financePaymentsCurrentPageSelector = createSelector(
  [(state: RootState) => state.financeAdmin.payments.current_page],
  currentPage => currentPage ?? 0,
);

export const financePaymentsTotalPagesSelector = createSelector(
  [(state: RootState) => state.financeAdmin.payments.total_pages],
  totalPages => totalPages ?? 0,
);

export const financePaymentsTotalResultsSelector = createSelector(
  [(state: RootState) => state.financeAdmin.payments.total_results],
  totalResults => totalResults ?? 0,
);

export const specialistPayoutsSelector = createSelector(
  [(state: RootState) => state.financeAdmin.specialistPayouts?.payouts],
  payouts => payouts || [],
);

export const specialistPayoutsNextPageSelector = createSelector(
  [(state: RootState) => state.financeAdmin.specialistPayouts?.next_page],
  nextPage => nextPage ?? null,
);

export const specialistPayoutsCurrentPageSelector = createSelector(
  [(state: RootState) => state.financeAdmin.specialistPayouts?.current_page],
  currentPage => currentPage ?? 0,
);

export const specialistPayoutsTotalPagesSelector = createSelector(
  [(state: RootState) => state.financeAdmin.specialistPayouts?.total_pages],
  totalPages => totalPages ?? 0,
);

export const specialistPayoutsTotalResultsSelector = createSelector(
  [(state: RootState) => state.financeAdmin.specialistPayouts?.total_results],
  totalResults => totalResults ?? 0,
);

